/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreatePatientInput = {
  id?: string | null,
  facilityId: string,
  karteNo?: string | null,
  zipCode?: string | null,
  address?: string | null,
  state?: string | null,
  city?: string | null,
  familyName: string,
  firstName: string,
  familyNameKana: string,
  firstNameKana: string,
  email: string,
  phoneNumber: string,
  dateOfBirth?: string | null,
  gender?: number | null,
  mynumbercard?: boolean | null,
  seinenhikoukennin?: boolean | null,
  vip: boolean,
  memberStatus?: string | null,
  contractState?: Array< AgreeStateInput | null > | null,
  kaisekiKenriNoKyodaku?: boolean | null,
  eturankenKyodaku?: boolean | null,
  tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
  koukokuUketoriNoKyodaku?: boolean | null,
  minimumAdvertisedPrice?: number | null,
  designationOfMinimumTransactionPrice?: number | null,
  kouekiKenkyuuMushouRiyou?: boolean | null,
  houkatuDoui?: boolean | null,
  torihikiGoui?: boolean | null,
  tudoKeiyakuKakunin?: boolean | null,
  lineUserId?: string | null,
  isWalletCreate?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  isLineNotificationEnabled?: boolean | null,
};

export type AgreeStateInput = {
  clinicName: string,
  termsAgree?: number | null,
  infoAgree?: number | null,
};

export type ModelPatientConditionInput = {
  facilityId?: ModelStringInput | null,
  karteNo?: ModelStringInput | null,
  zipCode?: ModelStringInput | null,
  address?: ModelStringInput | null,
  state?: ModelStringInput | null,
  city?: ModelStringInput | null,
  familyName?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  familyNameKana?: ModelStringInput | null,
  firstNameKana?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  dateOfBirth?: ModelStringInput | null,
  gender?: ModelIntInput | null,
  mynumbercard?: ModelBooleanInput | null,
  seinenhikoukennin?: ModelBooleanInput | null,
  vip?: ModelBooleanInput | null,
  memberStatus?: ModelStringInput | null,
  kaisekiKenriNoKyodaku?: ModelBooleanInput | null,
  eturankenKyodaku?: ModelBooleanInput | null,
  tokumeiKakouJouhouHukuseiNoKyodaku?: ModelBooleanInput | null,
  koukokuUketoriNoKyodaku?: ModelBooleanInput | null,
  minimumAdvertisedPrice?: ModelFloatInput | null,
  designationOfMinimumTransactionPrice?: ModelFloatInput | null,
  kouekiKenkyuuMushouRiyou?: ModelBooleanInput | null,
  houkatuDoui?: ModelBooleanInput | null,
  torihikiGoui?: ModelBooleanInput | null,
  tudoKeiyakuKakunin?: ModelBooleanInput | null,
  lineUserId?: ModelStringInput | null,
  isWalletCreate?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  isLineNotificationEnabled?: ModelBooleanInput | null,
  and?: Array< ModelPatientConditionInput | null > | null,
  or?: Array< ModelPatientConditionInput | null > | null,
  not?: ModelPatientConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Patient = {
  __typename: "Patient",
  id: string,
  facilityId: string,
  karteNo?: string | null,
  zipCode?: string | null,
  address?: string | null,
  state?: string | null,
  city?: string | null,
  familyName: string,
  firstName: string,
  familyNameKana: string,
  firstNameKana: string,
  email: string,
  phoneNumber: string,
  dateOfBirth?: string | null,
  gender?: number | null,
  mynumbercard?: boolean | null,
  seinenhikoukennin?: boolean | null,
  vip: boolean,
  memberStatus?: string | null,
  contractState?:  Array<AgreeState | null > | null,
  kaisekiKenriNoKyodaku?: boolean | null,
  eturankenKyodaku?: boolean | null,
  tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
  koukokuUketoriNoKyodaku?: boolean | null,
  minimumAdvertisedPrice?: number | null,
  designationOfMinimumTransactionPrice?: number | null,
  kouekiKenkyuuMushouRiyou?: boolean | null,
  houkatuDoui?: boolean | null,
  torihikiGoui?: boolean | null,
  tudoKeiyakuKakunin?: boolean | null,
  lineUserId?: string | null,
  isWalletCreate?: boolean | null,
  createdAt: string,
  updatedAt: string,
  isLineNotificationEnabled?: boolean | null,
  owner?: string | null,
};

export type AgreeState = {
  __typename: "AgreeState",
  clinicName: string,
  termsAgree?: number | null,
  infoAgree?: number | null,
};

export type UpdatePatientInput = {
  id: string,
  facilityId?: string | null,
  karteNo?: string | null,
  zipCode?: string | null,
  address?: string | null,
  state?: string | null,
  city?: string | null,
  familyName?: string | null,
  firstName?: string | null,
  familyNameKana?: string | null,
  firstNameKana?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  dateOfBirth?: string | null,
  gender?: number | null,
  mynumbercard?: boolean | null,
  seinenhikoukennin?: boolean | null,
  vip?: boolean | null,
  memberStatus?: string | null,
  contractState?: Array< AgreeStateInput | null > | null,
  kaisekiKenriNoKyodaku?: boolean | null,
  eturankenKyodaku?: boolean | null,
  tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
  koukokuUketoriNoKyodaku?: boolean | null,
  minimumAdvertisedPrice?: number | null,
  designationOfMinimumTransactionPrice?: number | null,
  kouekiKenkyuuMushouRiyou?: boolean | null,
  houkatuDoui?: boolean | null,
  torihikiGoui?: boolean | null,
  tudoKeiyakuKakunin?: boolean | null,
  lineUserId?: string | null,
  isWalletCreate?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  isLineNotificationEnabled?: boolean | null,
};

export type DeletePatientInput = {
  id: string,
};

export type CreateReservationInput = {
  id?: string | null,
  patientId: string,
  symptoms: string,
  symptomOthers: string,
  examinationMenuId: string,
  remarks: string,
  dateTime: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelReservationConditionInput = {
  patientId?: ModelStringInput | null,
  symptoms?: ModelStringInput | null,
  symptomOthers?: ModelStringInput | null,
  examinationMenuId?: ModelStringInput | null,
  remarks?: ModelStringInput | null,
  dateTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReservationConditionInput | null > | null,
  or?: Array< ModelReservationConditionInput | null > | null,
  not?: ModelReservationConditionInput | null,
};

export type Reservation = {
  __typename: "Reservation",
  id: string,
  patientId: string,
  symptoms: string,
  symptomOthers: string,
  examinationMenuId: string,
  remarks: string,
  dateTime: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateReservationInput = {
  id: string,
  patientId?: string | null,
  symptoms?: string | null,
  symptomOthers?: string | null,
  examinationMenuId?: string | null,
  remarks?: string | null,
  dateTime?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteReservationInput = {
  id: string,
};

export type CreateObservationInput = {
  id?: string | null,
  patientId: string,
  reservationId: string,
  height: number,
  weight: number,
  treatmentOfRecentInjuriesReceived: boolean,
  purposeOfExamination: Array< string | null >,
  purposeOfExaminationOtherReason?: string | null,
  areaToBeInspected: string,
  jobType: Array< string | null >,
  jobTypeOtherReason?: string | null,
  workplaceTransferMethod: Array< string | null >,
  workplaceTransferMethodOtherReason?: string | null,
  walkingHabit: Array< string | null >,
  aidsForWalking: Array< string | null >,
  createdInHospitalsAndClinics: Array< string | null >,
  insuranceCoverageForOrthoticDevices: boolean,
  unintentionalWeightLossOfMoreThan2kgInTheLast6Months: boolean,
  feelingTiredForNoReasonInTheLastTwoWeeks: boolean,
  lightExerciseForHealthPurposes: boolean,
  canYouOpenTheLidOfAPlasticBottle: boolean,
  diseasesRelatedToOrthopedics: Array< string | null >,
  sprainLocation?: string | null,
  fractureLocation?: string | null,
  diseasesRelatedToOrthopedicsOtherReason?: string | null,
  injuries1: string,
  injuries2: string,
  nameOfDrugAllergyMedication: string,
  nameOfMedicationIfAllergicToAnesthesia: string,
  otherAllergies: Array< string | null >,
  otherAllergiesOtherReason?: string | null,
  medicationsCurrentlyBeingTaken: Array< string | null >,
  medicationsCurrentlyBeingTakenOtherReason?: string | null,
  supplementsCurrentlyBeingTaken: string,
  aboutCigarettes: Array< string | null >,
  numberOfCigarettesSmokedDaily: number,
  numberOfYearsSmoked: number,
  aboutAlcohol: Array< string | null >,
  pregnancy: boolean,
  historyOfChildbirth: boolean,
  aboutFamilyDoctor: string,
  primaryNursingCareRequirementAuthorization: Array< string | null >,
  footSymptomsOfConcern: Array< string | null >,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelObservationConditionInput = {
  patientId?: ModelStringInput | null,
  reservationId?: ModelStringInput | null,
  height?: ModelIntInput | null,
  weight?: ModelIntInput | null,
  treatmentOfRecentInjuriesReceived?: ModelBooleanInput | null,
  purposeOfExamination?: ModelStringInput | null,
  purposeOfExaminationOtherReason?: ModelStringInput | null,
  areaToBeInspected?: ModelStringInput | null,
  jobType?: ModelStringInput | null,
  jobTypeOtherReason?: ModelStringInput | null,
  workplaceTransferMethod?: ModelStringInput | null,
  workplaceTransferMethodOtherReason?: ModelStringInput | null,
  walkingHabit?: ModelStringInput | null,
  aidsForWalking?: ModelStringInput | null,
  createdInHospitalsAndClinics?: ModelStringInput | null,
  insuranceCoverageForOrthoticDevices?: ModelBooleanInput | null,
  unintentionalWeightLossOfMoreThan2kgInTheLast6Months?: ModelBooleanInput | null,
  feelingTiredForNoReasonInTheLastTwoWeeks?: ModelBooleanInput | null,
  lightExerciseForHealthPurposes?: ModelBooleanInput | null,
  canYouOpenTheLidOfAPlasticBottle?: ModelBooleanInput | null,
  diseasesRelatedToOrthopedics?: ModelStringInput | null,
  sprainLocation?: ModelStringInput | null,
  fractureLocation?: ModelStringInput | null,
  diseasesRelatedToOrthopedicsOtherReason?: ModelStringInput | null,
  injuries1?: ModelStringInput | null,
  injuries2?: ModelStringInput | null,
  nameOfDrugAllergyMedication?: ModelStringInput | null,
  nameOfMedicationIfAllergicToAnesthesia?: ModelStringInput | null,
  otherAllergies?: ModelStringInput | null,
  otherAllergiesOtherReason?: ModelStringInput | null,
  medicationsCurrentlyBeingTaken?: ModelStringInput | null,
  medicationsCurrentlyBeingTakenOtherReason?: ModelStringInput | null,
  supplementsCurrentlyBeingTaken?: ModelStringInput | null,
  aboutCigarettes?: ModelStringInput | null,
  numberOfCigarettesSmokedDaily?: ModelIntInput | null,
  numberOfYearsSmoked?: ModelIntInput | null,
  aboutAlcohol?: ModelStringInput | null,
  pregnancy?: ModelBooleanInput | null,
  historyOfChildbirth?: ModelBooleanInput | null,
  aboutFamilyDoctor?: ModelStringInput | null,
  primaryNursingCareRequirementAuthorization?: ModelStringInput | null,
  footSymptomsOfConcern?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelObservationConditionInput | null > | null,
  or?: Array< ModelObservationConditionInput | null > | null,
  not?: ModelObservationConditionInput | null,
};

export type Observation = {
  __typename: "Observation",
  id: string,
  patientId: string,
  reservationId: string,
  height: number,
  weight: number,
  treatmentOfRecentInjuriesReceived: boolean,
  purposeOfExamination: Array< string | null >,
  purposeOfExaminationOtherReason?: string | null,
  areaToBeInspected: string,
  jobType: Array< string | null >,
  jobTypeOtherReason?: string | null,
  workplaceTransferMethod: Array< string | null >,
  workplaceTransferMethodOtherReason?: string | null,
  walkingHabit: Array< string | null >,
  aidsForWalking: Array< string | null >,
  createdInHospitalsAndClinics: Array< string | null >,
  insuranceCoverageForOrthoticDevices: boolean,
  unintentionalWeightLossOfMoreThan2kgInTheLast6Months: boolean,
  feelingTiredForNoReasonInTheLastTwoWeeks: boolean,
  lightExerciseForHealthPurposes: boolean,
  canYouOpenTheLidOfAPlasticBottle: boolean,
  diseasesRelatedToOrthopedics: Array< string | null >,
  sprainLocation?: string | null,
  fractureLocation?: string | null,
  diseasesRelatedToOrthopedicsOtherReason?: string | null,
  injuries1: string,
  injuries2: string,
  nameOfDrugAllergyMedication: string,
  nameOfMedicationIfAllergicToAnesthesia: string,
  otherAllergies: Array< string | null >,
  otherAllergiesOtherReason?: string | null,
  medicationsCurrentlyBeingTaken: Array< string | null >,
  medicationsCurrentlyBeingTakenOtherReason?: string | null,
  supplementsCurrentlyBeingTaken: string,
  aboutCigarettes: Array< string | null >,
  numberOfCigarettesSmokedDaily: number,
  numberOfYearsSmoked: number,
  aboutAlcohol: Array< string | null >,
  pregnancy: boolean,
  historyOfChildbirth: boolean,
  aboutFamilyDoctor: string,
  primaryNursingCareRequirementAuthorization: Array< string | null >,
  footSymptomsOfConcern: Array< string | null >,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateObservationInput = {
  id: string,
  patientId?: string | null,
  reservationId?: string | null,
  height?: number | null,
  weight?: number | null,
  treatmentOfRecentInjuriesReceived?: boolean | null,
  purposeOfExamination?: Array< string | null > | null,
  purposeOfExaminationOtherReason?: string | null,
  areaToBeInspected?: string | null,
  jobType?: Array< string | null > | null,
  jobTypeOtherReason?: string | null,
  workplaceTransferMethod?: Array< string | null > | null,
  workplaceTransferMethodOtherReason?: string | null,
  walkingHabit?: Array< string | null > | null,
  aidsForWalking?: Array< string | null > | null,
  createdInHospitalsAndClinics?: Array< string | null > | null,
  insuranceCoverageForOrthoticDevices?: boolean | null,
  unintentionalWeightLossOfMoreThan2kgInTheLast6Months?: boolean | null,
  feelingTiredForNoReasonInTheLastTwoWeeks?: boolean | null,
  lightExerciseForHealthPurposes?: boolean | null,
  canYouOpenTheLidOfAPlasticBottle?: boolean | null,
  diseasesRelatedToOrthopedics?: Array< string | null > | null,
  sprainLocation?: string | null,
  fractureLocation?: string | null,
  diseasesRelatedToOrthopedicsOtherReason?: string | null,
  injuries1?: string | null,
  injuries2?: string | null,
  nameOfDrugAllergyMedication?: string | null,
  nameOfMedicationIfAllergicToAnesthesia?: string | null,
  otherAllergies?: Array< string | null > | null,
  otherAllergiesOtherReason?: string | null,
  medicationsCurrentlyBeingTaken?: Array< string | null > | null,
  medicationsCurrentlyBeingTakenOtherReason?: string | null,
  supplementsCurrentlyBeingTaken?: string | null,
  aboutCigarettes?: Array< string | null > | null,
  numberOfCigarettesSmokedDaily?: number | null,
  numberOfYearsSmoked?: number | null,
  aboutAlcohol?: Array< string | null > | null,
  pregnancy?: boolean | null,
  historyOfChildbirth?: boolean | null,
  aboutFamilyDoctor?: string | null,
  primaryNursingCareRequirementAuthorization?: Array< string | null > | null,
  footSymptomsOfConcern?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteObservationInput = {
  id: string,
};

export type CreateReceptionInput = {
  id?: string | null,
  patientId: string,
  date: string,
  outpatientId: string,
  outpatientName: string,
  startTime: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelReceptionConditionInput = {
  patientId?: ModelStringInput | null,
  date?: ModelStringInput | null,
  outpatientId?: ModelStringInput | null,
  outpatientName?: ModelStringInput | null,
  startTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReceptionConditionInput | null > | null,
  or?: Array< ModelReceptionConditionInput | null > | null,
  not?: ModelReceptionConditionInput | null,
};

export type Reception = {
  __typename: "Reception",
  id: string,
  patientId: string,
  date: string,
  outpatientId: string,
  outpatientName: string,
  startTime: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateReceptionInput = {
  id: string,
  patientId?: string | null,
  date?: string | null,
  outpatientId?: string | null,
  outpatientName?: string | null,
  startTime?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteReceptionInput = {
  id: string,
};

export type CreateContractInput = {
  id?: string | null,
  clinicName: string,
  isMedical: boolean,
  medicalTreatment?: Array< MedicalTreatmentContentInput | null > | null,
  infoAgree: string,
  termsAndConditions: string,
};

export type MedicalTreatmentContentInput = {
  title: string,
  detail: string,
};

export type ModelContractConditionInput = {
  clinicName?: ModelStringInput | null,
  isMedical?: ModelBooleanInput | null,
  infoAgree?: ModelStringInput | null,
  termsAndConditions?: ModelStringInput | null,
  and?: Array< ModelContractConditionInput | null > | null,
  or?: Array< ModelContractConditionInput | null > | null,
  not?: ModelContractConditionInput | null,
};

export type Contract = {
  __typename: "Contract",
  id: string,
  clinicName: string,
  isMedical: boolean,
  medicalTreatment?:  Array<MedicalTreatmentContent | null > | null,
  infoAgree: string,
  termsAndConditions: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type MedicalTreatmentContent = {
  __typename: "MedicalTreatmentContent",
  title: string,
  detail: string,
};

export type UpdateContractInput = {
  id: string,
  clinicName?: string | null,
  isMedical?: boolean | null,
  medicalTreatment?: Array< MedicalTreatmentContentInput | null > | null,
  infoAgree?: string | null,
  termsAndConditions?: string | null,
};

export type DeleteContractInput = {
  id: string,
};

export type CreateNotificationInput = {
  id?: string | null,
  patientId: string,
  facilityId: string,
  patientIdFacilityId: string,
  createdAt?: string | null,
  altText?: string | null,
  title?: string | null,
  message: string,
  notificationType: string,
  buttonType?: string | null,
  actionType?: string | null,
  actionValue?: Array< string | null > | null,
  choices?: Array< string | null > | null,
  isRead: boolean,
};

export type ModelNotificationConditionInput = {
  patientId?: ModelIDInput | null,
  facilityId?: ModelStringInput | null,
  patientIdFacilityId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  altText?: ModelStringInput | null,
  title?: ModelStringInput | null,
  message?: ModelStringInput | null,
  notificationType?: ModelStringInput | null,
  buttonType?: ModelStringInput | null,
  actionType?: ModelStringInput | null,
  actionValue?: ModelStringInput | null,
  choices?: ModelStringInput | null,
  isRead?: ModelBooleanInput | null,
  and?: Array< ModelNotificationConditionInput | null > | null,
  or?: Array< ModelNotificationConditionInput | null > | null,
  not?: ModelNotificationConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type Notification = {
  __typename: "Notification",
  id: string,
  patientId: string,
  facilityId: string,
  patientIdFacilityId: string,
  createdAt: string,
  altText?: string | null,
  title?: string | null,
  message: string,
  notificationType: string,
  buttonType?: string | null,
  actionType?: string | null,
  actionValue?: Array< string | null > | null,
  choices?: Array< string | null > | null,
  isRead: boolean,
  updatedAt: string,
};

export type UpdateNotificationInput = {
  id: string,
  patientId?: string | null,
  facilityId?: string | null,
  patientIdFacilityId?: string | null,
  createdAt?: string | null,
  altText?: string | null,
  title?: string | null,
  message?: string | null,
  notificationType?: string | null,
  buttonType?: string | null,
  actionType?: string | null,
  actionValue?: Array< string | null > | null,
  choices?: Array< string | null > | null,
  isRead?: boolean | null,
};

export type DeleteNotificationInput = {
  id: string,
};

export type CreateRetryNotificationsInput = {
  id?: string | null,
  sendMessage: string,
};

export type ModelRetryNotificationsConditionInput = {
  sendMessage?: ModelStringInput | null,
  and?: Array< ModelRetryNotificationsConditionInput | null > | null,
  or?: Array< ModelRetryNotificationsConditionInput | null > | null,
  not?: ModelRetryNotificationsConditionInput | null,
};

export type RetryNotifications = {
  __typename: "RetryNotifications",
  id: string,
  sendMessage: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateRetryNotificationsInput = {
  id: string,
  sendMessage?: string | null,
};

export type DeleteRetryNotificationsInput = {
  id: string,
};

export type CreateFacilityPatientsInput = {
  facilityId: string,
  patientId: string,
  lineUserId?: string | null,
  karteNo?: string | null,
  vip: boolean,
  isFirstVisit?: boolean | null,
  memberStatus?: string | null,
  insuranceType?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelFacilityPatientsConditionInput = {
  lineUserId?: ModelStringInput | null,
  karteNo?: ModelStringInput | null,
  vip?: ModelBooleanInput | null,
  isFirstVisit?: ModelBooleanInput | null,
  memberStatus?: ModelStringInput | null,
  insuranceType?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFacilityPatientsConditionInput | null > | null,
  or?: Array< ModelFacilityPatientsConditionInput | null > | null,
  not?: ModelFacilityPatientsConditionInput | null,
};

export type FacilityPatients = {
  __typename: "FacilityPatients",
  facilityId: string,
  patientId: string,
  lineUserId?: string | null,
  karteNo?: string | null,
  vip: boolean,
  isFirstVisit?: boolean | null,
  memberStatus?: string | null,
  insuranceType?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateFacilityPatientsInput = {
  facilityId: string,
  patientId: string,
  lineUserId?: string | null,
  karteNo?: string | null,
  vip?: boolean | null,
  isFirstVisit?: boolean | null,
  memberStatus?: string | null,
  insuranceType?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteFacilityPatientsInput = {
  patientId: string,
  facilityId: string,
};

export type ModelPatientFilterInput = {
  id?: ModelIDInput | null,
  facilityId?: ModelStringInput | null,
  karteNo?: ModelStringInput | null,
  zipCode?: ModelStringInput | null,
  address?: ModelStringInput | null,
  state?: ModelStringInput | null,
  city?: ModelStringInput | null,
  familyName?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  familyNameKana?: ModelStringInput | null,
  firstNameKana?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  dateOfBirth?: ModelStringInput | null,
  gender?: ModelIntInput | null,
  mynumbercard?: ModelBooleanInput | null,
  seinenhikoukennin?: ModelBooleanInput | null,
  vip?: ModelBooleanInput | null,
  memberStatus?: ModelStringInput | null,
  kaisekiKenriNoKyodaku?: ModelBooleanInput | null,
  eturankenKyodaku?: ModelBooleanInput | null,
  tokumeiKakouJouhouHukuseiNoKyodaku?: ModelBooleanInput | null,
  koukokuUketoriNoKyodaku?: ModelBooleanInput | null,
  minimumAdvertisedPrice?: ModelFloatInput | null,
  designationOfMinimumTransactionPrice?: ModelFloatInput | null,
  kouekiKenkyuuMushouRiyou?: ModelBooleanInput | null,
  houkatuDoui?: ModelBooleanInput | null,
  torihikiGoui?: ModelBooleanInput | null,
  tudoKeiyakuKakunin?: ModelBooleanInput | null,
  lineUserId?: ModelStringInput | null,
  isWalletCreate?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  isLineNotificationEnabled?: ModelBooleanInput | null,
  and?: Array< ModelPatientFilterInput | null > | null,
  or?: Array< ModelPatientFilterInput | null > | null,
  not?: ModelPatientFilterInput | null,
};

export type ModelPatientConnection = {
  __typename: "ModelPatientConnection",
  items:  Array<Patient | null >,
  nextToken?: string | null,
};

export type ModelReservationFilterInput = {
  id?: ModelIDInput | null,
  patientId?: ModelStringInput | null,
  symptoms?: ModelStringInput | null,
  symptomOthers?: ModelStringInput | null,
  examinationMenuId?: ModelStringInput | null,
  remarks?: ModelStringInput | null,
  dateTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReservationFilterInput | null > | null,
  or?: Array< ModelReservationFilterInput | null > | null,
  not?: ModelReservationFilterInput | null,
};

export type ModelReservationConnection = {
  __typename: "ModelReservationConnection",
  items:  Array<Reservation | null >,
  nextToken?: string | null,
};

export type ModelObservationFilterInput = {
  id?: ModelIDInput | null,
  patientId?: ModelStringInput | null,
  reservationId?: ModelStringInput | null,
  height?: ModelIntInput | null,
  weight?: ModelIntInput | null,
  treatmentOfRecentInjuriesReceived?: ModelBooleanInput | null,
  purposeOfExamination?: ModelStringInput | null,
  purposeOfExaminationOtherReason?: ModelStringInput | null,
  areaToBeInspected?: ModelStringInput | null,
  jobType?: ModelStringInput | null,
  jobTypeOtherReason?: ModelStringInput | null,
  workplaceTransferMethod?: ModelStringInput | null,
  workplaceTransferMethodOtherReason?: ModelStringInput | null,
  walkingHabit?: ModelStringInput | null,
  aidsForWalking?: ModelStringInput | null,
  createdInHospitalsAndClinics?: ModelStringInput | null,
  insuranceCoverageForOrthoticDevices?: ModelBooleanInput | null,
  unintentionalWeightLossOfMoreThan2kgInTheLast6Months?: ModelBooleanInput | null,
  feelingTiredForNoReasonInTheLastTwoWeeks?: ModelBooleanInput | null,
  lightExerciseForHealthPurposes?: ModelBooleanInput | null,
  canYouOpenTheLidOfAPlasticBottle?: ModelBooleanInput | null,
  diseasesRelatedToOrthopedics?: ModelStringInput | null,
  sprainLocation?: ModelStringInput | null,
  fractureLocation?: ModelStringInput | null,
  diseasesRelatedToOrthopedicsOtherReason?: ModelStringInput | null,
  injuries1?: ModelStringInput | null,
  injuries2?: ModelStringInput | null,
  nameOfDrugAllergyMedication?: ModelStringInput | null,
  nameOfMedicationIfAllergicToAnesthesia?: ModelStringInput | null,
  otherAllergies?: ModelStringInput | null,
  otherAllergiesOtherReason?: ModelStringInput | null,
  medicationsCurrentlyBeingTaken?: ModelStringInput | null,
  medicationsCurrentlyBeingTakenOtherReason?: ModelStringInput | null,
  supplementsCurrentlyBeingTaken?: ModelStringInput | null,
  aboutCigarettes?: ModelStringInput | null,
  numberOfCigarettesSmokedDaily?: ModelIntInput | null,
  numberOfYearsSmoked?: ModelIntInput | null,
  aboutAlcohol?: ModelStringInput | null,
  pregnancy?: ModelBooleanInput | null,
  historyOfChildbirth?: ModelBooleanInput | null,
  aboutFamilyDoctor?: ModelStringInput | null,
  primaryNursingCareRequirementAuthorization?: ModelStringInput | null,
  footSymptomsOfConcern?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelObservationFilterInput | null > | null,
  or?: Array< ModelObservationFilterInput | null > | null,
  not?: ModelObservationFilterInput | null,
};

export type ModelObservationConnection = {
  __typename: "ModelObservationConnection",
  items:  Array<Observation | null >,
  nextToken?: string | null,
};

export type ModelReceptionFilterInput = {
  id?: ModelIDInput | null,
  patientId?: ModelStringInput | null,
  date?: ModelStringInput | null,
  outpatientId?: ModelStringInput | null,
  outpatientName?: ModelStringInput | null,
  startTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReceptionFilterInput | null > | null,
  or?: Array< ModelReceptionFilterInput | null > | null,
  not?: ModelReceptionFilterInput | null,
};

export type ModelReceptionConnection = {
  __typename: "ModelReceptionConnection",
  items:  Array<Reception | null >,
  nextToken?: string | null,
};

export type ModelContractFilterInput = {
  id?: ModelIDInput | null,
  clinicName?: ModelStringInput | null,
  isMedical?: ModelBooleanInput | null,
  infoAgree?: ModelStringInput | null,
  termsAndConditions?: ModelStringInput | null,
  and?: Array< ModelContractFilterInput | null > | null,
  or?: Array< ModelContractFilterInput | null > | null,
  not?: ModelContractFilterInput | null,
};

export type ModelContractConnection = {
  __typename: "ModelContractConnection",
  items:  Array<Contract | null >,
  nextToken?: string | null,
};

export type ModelNotificationFilterInput = {
  id?: ModelIDInput | null,
  patientId?: ModelIDInput | null,
  facilityId?: ModelStringInput | null,
  patientIdFacilityId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  altText?: ModelStringInput | null,
  title?: ModelStringInput | null,
  message?: ModelStringInput | null,
  notificationType?: ModelStringInput | null,
  buttonType?: ModelStringInput | null,
  actionType?: ModelStringInput | null,
  actionValue?: ModelStringInput | null,
  choices?: ModelStringInput | null,
  isRead?: ModelBooleanInput | null,
  and?: Array< ModelNotificationFilterInput | null > | null,
  or?: Array< ModelNotificationFilterInput | null > | null,
  not?: ModelNotificationFilterInput | null,
};

export type ModelNotificationConnection = {
  __typename: "ModelNotificationConnection",
  items:  Array<Notification | null >,
  nextToken?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelRetryNotificationsFilterInput = {
  id?: ModelIDInput | null,
  sendMessage?: ModelStringInput | null,
  and?: Array< ModelRetryNotificationsFilterInput | null > | null,
  or?: Array< ModelRetryNotificationsFilterInput | null > | null,
  not?: ModelRetryNotificationsFilterInput | null,
};

export type ModelRetryNotificationsConnection = {
  __typename: "ModelRetryNotificationsConnection",
  items:  Array<RetryNotifications | null >,
  nextToken?: string | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelFacilityPatientsFilterInput = {
  facilityId?: ModelIDInput | null,
  patientId?: ModelIDInput | null,
  lineUserId?: ModelStringInput | null,
  karteNo?: ModelStringInput | null,
  vip?: ModelBooleanInput | null,
  isFirstVisit?: ModelBooleanInput | null,
  memberStatus?: ModelStringInput | null,
  insuranceType?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFacilityPatientsFilterInput | null > | null,
  or?: Array< ModelFacilityPatientsFilterInput | null > | null,
  not?: ModelFacilityPatientsFilterInput | null,
};

export type ModelFacilityPatientsConnection = {
  __typename: "ModelFacilityPatientsConnection",
  items:  Array<FacilityPatients | null >,
  nextToken?: string | null,
};

export type ModelSubscriptionPatientFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  facilityId?: ModelSubscriptionStringInput | null,
  karteNo?: ModelSubscriptionStringInput | null,
  zipCode?: ModelSubscriptionStringInput | null,
  address?: ModelSubscriptionStringInput | null,
  state?: ModelSubscriptionStringInput | null,
  city?: ModelSubscriptionStringInput | null,
  familyName?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  familyNameKana?: ModelSubscriptionStringInput | null,
  firstNameKana?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  dateOfBirth?: ModelSubscriptionStringInput | null,
  gender?: ModelSubscriptionIntInput | null,
  mynumbercard?: ModelSubscriptionBooleanInput | null,
  seinenhikoukennin?: ModelSubscriptionBooleanInput | null,
  vip?: ModelSubscriptionBooleanInput | null,
  memberStatus?: ModelSubscriptionStringInput | null,
  kaisekiKenriNoKyodaku?: ModelSubscriptionBooleanInput | null,
  eturankenKyodaku?: ModelSubscriptionBooleanInput | null,
  tokumeiKakouJouhouHukuseiNoKyodaku?: ModelSubscriptionBooleanInput | null,
  koukokuUketoriNoKyodaku?: ModelSubscriptionBooleanInput | null,
  minimumAdvertisedPrice?: ModelSubscriptionFloatInput | null,
  designationOfMinimumTransactionPrice?: ModelSubscriptionFloatInput | null,
  kouekiKenkyuuMushouRiyou?: ModelSubscriptionBooleanInput | null,
  houkatuDoui?: ModelSubscriptionBooleanInput | null,
  torihikiGoui?: ModelSubscriptionBooleanInput | null,
  tudoKeiyakuKakunin?: ModelSubscriptionBooleanInput | null,
  lineUserId?: ModelSubscriptionStringInput | null,
  isWalletCreate?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  isLineNotificationEnabled?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionPatientFilterInput | null > | null,
  or?: Array< ModelSubscriptionPatientFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionReservationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  patientId?: ModelSubscriptionStringInput | null,
  symptoms?: ModelSubscriptionStringInput | null,
  symptomOthers?: ModelSubscriptionStringInput | null,
  examinationMenuId?: ModelSubscriptionStringInput | null,
  remarks?: ModelSubscriptionStringInput | null,
  dateTime?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionReservationFilterInput | null > | null,
  or?: Array< ModelSubscriptionReservationFilterInput | null > | null,
};

export type ModelSubscriptionObservationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  patientId?: ModelSubscriptionStringInput | null,
  reservationId?: ModelSubscriptionStringInput | null,
  height?: ModelSubscriptionIntInput | null,
  weight?: ModelSubscriptionIntInput | null,
  treatmentOfRecentInjuriesReceived?: ModelSubscriptionBooleanInput | null,
  purposeOfExamination?: ModelSubscriptionStringInput | null,
  purposeOfExaminationOtherReason?: ModelSubscriptionStringInput | null,
  areaToBeInspected?: ModelSubscriptionStringInput | null,
  jobType?: ModelSubscriptionStringInput | null,
  jobTypeOtherReason?: ModelSubscriptionStringInput | null,
  workplaceTransferMethod?: ModelSubscriptionStringInput | null,
  workplaceTransferMethodOtherReason?: ModelSubscriptionStringInput | null,
  walkingHabit?: ModelSubscriptionStringInput | null,
  aidsForWalking?: ModelSubscriptionStringInput | null,
  createdInHospitalsAndClinics?: ModelSubscriptionStringInput | null,
  insuranceCoverageForOrthoticDevices?: ModelSubscriptionBooleanInput | null,
  unintentionalWeightLossOfMoreThan2kgInTheLast6Months?: ModelSubscriptionBooleanInput | null,
  feelingTiredForNoReasonInTheLastTwoWeeks?: ModelSubscriptionBooleanInput | null,
  lightExerciseForHealthPurposes?: ModelSubscriptionBooleanInput | null,
  canYouOpenTheLidOfAPlasticBottle?: ModelSubscriptionBooleanInput | null,
  diseasesRelatedToOrthopedics?: ModelSubscriptionStringInput | null,
  sprainLocation?: ModelSubscriptionStringInput | null,
  fractureLocation?: ModelSubscriptionStringInput | null,
  diseasesRelatedToOrthopedicsOtherReason?: ModelSubscriptionStringInput | null,
  injuries1?: ModelSubscriptionStringInput | null,
  injuries2?: ModelSubscriptionStringInput | null,
  nameOfDrugAllergyMedication?: ModelSubscriptionStringInput | null,
  nameOfMedicationIfAllergicToAnesthesia?: ModelSubscriptionStringInput | null,
  otherAllergies?: ModelSubscriptionStringInput | null,
  otherAllergiesOtherReason?: ModelSubscriptionStringInput | null,
  medicationsCurrentlyBeingTaken?: ModelSubscriptionStringInput | null,
  medicationsCurrentlyBeingTakenOtherReason?: ModelSubscriptionStringInput | null,
  supplementsCurrentlyBeingTaken?: ModelSubscriptionStringInput | null,
  aboutCigarettes?: ModelSubscriptionStringInput | null,
  numberOfCigarettesSmokedDaily?: ModelSubscriptionIntInput | null,
  numberOfYearsSmoked?: ModelSubscriptionIntInput | null,
  aboutAlcohol?: ModelSubscriptionStringInput | null,
  pregnancy?: ModelSubscriptionBooleanInput | null,
  historyOfChildbirth?: ModelSubscriptionBooleanInput | null,
  aboutFamilyDoctor?: ModelSubscriptionStringInput | null,
  primaryNursingCareRequirementAuthorization?: ModelSubscriptionStringInput | null,
  footSymptomsOfConcern?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionObservationFilterInput | null > | null,
  or?: Array< ModelSubscriptionObservationFilterInput | null > | null,
};

export type ModelSubscriptionReceptionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  patientId?: ModelSubscriptionStringInput | null,
  date?: ModelSubscriptionStringInput | null,
  outpatientId?: ModelSubscriptionStringInput | null,
  outpatientName?: ModelSubscriptionStringInput | null,
  startTime?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionReceptionFilterInput | null > | null,
  or?: Array< ModelSubscriptionReceptionFilterInput | null > | null,
};

export type ModelSubscriptionContractFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  clinicName?: ModelSubscriptionStringInput | null,
  isMedical?: ModelSubscriptionBooleanInput | null,
  infoAgree?: ModelSubscriptionStringInput | null,
  termsAndConditions?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionContractFilterInput | null > | null,
  or?: Array< ModelSubscriptionContractFilterInput | null > | null,
};

export type ModelSubscriptionNotificationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  patientId?: ModelSubscriptionIDInput | null,
  facilityId?: ModelSubscriptionStringInput | null,
  patientIdFacilityId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  altText?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  message?: ModelSubscriptionStringInput | null,
  notificationType?: ModelSubscriptionStringInput | null,
  buttonType?: ModelSubscriptionStringInput | null,
  actionType?: ModelSubscriptionStringInput | null,
  actionValue?: ModelSubscriptionStringInput | null,
  choices?: ModelSubscriptionStringInput | null,
  isRead?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionNotificationFilterInput | null > | null,
  or?: Array< ModelSubscriptionNotificationFilterInput | null > | null,
};

export type ModelSubscriptionRetryNotificationsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  sendMessage?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRetryNotificationsFilterInput | null > | null,
  or?: Array< ModelSubscriptionRetryNotificationsFilterInput | null > | null,
};

export type ModelSubscriptionFacilityPatientsFilterInput = {
  facilityId?: ModelSubscriptionIDInput | null,
  patientId?: ModelSubscriptionIDInput | null,
  lineUserId?: ModelSubscriptionStringInput | null,
  karteNo?: ModelSubscriptionStringInput | null,
  vip?: ModelSubscriptionBooleanInput | null,
  isFirstVisit?: ModelSubscriptionBooleanInput | null,
  memberStatus?: ModelSubscriptionStringInput | null,
  insuranceType?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFacilityPatientsFilterInput | null > | null,
  or?: Array< ModelSubscriptionFacilityPatientsFilterInput | null > | null,
};

export type CreatePatientMutationVariables = {
  input: CreatePatientInput,
  condition?: ModelPatientConditionInput | null,
};

export type CreatePatientMutation = {
  createPatient?:  {
    __typename: "Patient",
    id: string,
    facilityId: string,
    karteNo?: string | null,
    zipCode?: string | null,
    address?: string | null,
    state?: string | null,
    city?: string | null,
    familyName: string,
    firstName: string,
    familyNameKana: string,
    firstNameKana: string,
    email: string,
    phoneNumber: string,
    dateOfBirth?: string | null,
    gender?: number | null,
    mynumbercard?: boolean | null,
    seinenhikoukennin?: boolean | null,
    vip: boolean,
    memberStatus?: string | null,
    contractState?:  Array< {
      __typename: "AgreeState",
      clinicName: string,
      termsAgree?: number | null,
      infoAgree?: number | null,
    } | null > | null,
    kaisekiKenriNoKyodaku?: boolean | null,
    eturankenKyodaku?: boolean | null,
    tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
    koukokuUketoriNoKyodaku?: boolean | null,
    minimumAdvertisedPrice?: number | null,
    designationOfMinimumTransactionPrice?: number | null,
    kouekiKenkyuuMushouRiyou?: boolean | null,
    houkatuDoui?: boolean | null,
    torihikiGoui?: boolean | null,
    tudoKeiyakuKakunin?: boolean | null,
    lineUserId?: string | null,
    isWalletCreate?: boolean | null,
    createdAt: string,
    updatedAt: string,
    isLineNotificationEnabled?: boolean | null,
    owner?: string | null,
  } | null,
};

export type UpdatePatientMutationVariables = {
  input: UpdatePatientInput,
  condition?: ModelPatientConditionInput | null,
};

export type UpdatePatientMutation = {
  updatePatient?:  {
    __typename: "Patient",
    id: string,
    facilityId: string,
    karteNo?: string | null,
    zipCode?: string | null,
    address?: string | null,
    state?: string | null,
    city?: string | null,
    familyName: string,
    firstName: string,
    familyNameKana: string,
    firstNameKana: string,
    email: string,
    phoneNumber: string,
    dateOfBirth?: string | null,
    gender?: number | null,
    mynumbercard?: boolean | null,
    seinenhikoukennin?: boolean | null,
    vip: boolean,
    memberStatus?: string | null,
    contractState?:  Array< {
      __typename: "AgreeState",
      clinicName: string,
      termsAgree?: number | null,
      infoAgree?: number | null,
    } | null > | null,
    kaisekiKenriNoKyodaku?: boolean | null,
    eturankenKyodaku?: boolean | null,
    tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
    koukokuUketoriNoKyodaku?: boolean | null,
    minimumAdvertisedPrice?: number | null,
    designationOfMinimumTransactionPrice?: number | null,
    kouekiKenkyuuMushouRiyou?: boolean | null,
    houkatuDoui?: boolean | null,
    torihikiGoui?: boolean | null,
    tudoKeiyakuKakunin?: boolean | null,
    lineUserId?: string | null,
    isWalletCreate?: boolean | null,
    createdAt: string,
    updatedAt: string,
    isLineNotificationEnabled?: boolean | null,
    owner?: string | null,
  } | null,
};

export type DeletePatientMutationVariables = {
  input: DeletePatientInput,
  condition?: ModelPatientConditionInput | null,
};

export type DeletePatientMutation = {
  deletePatient?:  {
    __typename: "Patient",
    id: string,
    facilityId: string,
    karteNo?: string | null,
    zipCode?: string | null,
    address?: string | null,
    state?: string | null,
    city?: string | null,
    familyName: string,
    firstName: string,
    familyNameKana: string,
    firstNameKana: string,
    email: string,
    phoneNumber: string,
    dateOfBirth?: string | null,
    gender?: number | null,
    mynumbercard?: boolean | null,
    seinenhikoukennin?: boolean | null,
    vip: boolean,
    memberStatus?: string | null,
    contractState?:  Array< {
      __typename: "AgreeState",
      clinicName: string,
      termsAgree?: number | null,
      infoAgree?: number | null,
    } | null > | null,
    kaisekiKenriNoKyodaku?: boolean | null,
    eturankenKyodaku?: boolean | null,
    tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
    koukokuUketoriNoKyodaku?: boolean | null,
    minimumAdvertisedPrice?: number | null,
    designationOfMinimumTransactionPrice?: number | null,
    kouekiKenkyuuMushouRiyou?: boolean | null,
    houkatuDoui?: boolean | null,
    torihikiGoui?: boolean | null,
    tudoKeiyakuKakunin?: boolean | null,
    lineUserId?: string | null,
    isWalletCreate?: boolean | null,
    createdAt: string,
    updatedAt: string,
    isLineNotificationEnabled?: boolean | null,
    owner?: string | null,
  } | null,
};

export type CreateReservationMutationVariables = {
  input: CreateReservationInput,
  condition?: ModelReservationConditionInput | null,
};

export type CreateReservationMutation = {
  createReservation?:  {
    __typename: "Reservation",
    id: string,
    patientId: string,
    symptoms: string,
    symptomOthers: string,
    examinationMenuId: string,
    remarks: string,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateReservationMutationVariables = {
  input: UpdateReservationInput,
  condition?: ModelReservationConditionInput | null,
};

export type UpdateReservationMutation = {
  updateReservation?:  {
    __typename: "Reservation",
    id: string,
    patientId: string,
    symptoms: string,
    symptomOthers: string,
    examinationMenuId: string,
    remarks: string,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteReservationMutationVariables = {
  input: DeleteReservationInput,
  condition?: ModelReservationConditionInput | null,
};

export type DeleteReservationMutation = {
  deleteReservation?:  {
    __typename: "Reservation",
    id: string,
    patientId: string,
    symptoms: string,
    symptomOthers: string,
    examinationMenuId: string,
    remarks: string,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateObservationMutationVariables = {
  input: CreateObservationInput,
  condition?: ModelObservationConditionInput | null,
};

export type CreateObservationMutation = {
  createObservation?:  {
    __typename: "Observation",
    id: string,
    patientId: string,
    reservationId: string,
    height: number,
    weight: number,
    treatmentOfRecentInjuriesReceived: boolean,
    purposeOfExamination: Array< string | null >,
    purposeOfExaminationOtherReason?: string | null,
    areaToBeInspected: string,
    jobType: Array< string | null >,
    jobTypeOtherReason?: string | null,
    workplaceTransferMethod: Array< string | null >,
    workplaceTransferMethodOtherReason?: string | null,
    walkingHabit: Array< string | null >,
    aidsForWalking: Array< string | null >,
    createdInHospitalsAndClinics: Array< string | null >,
    insuranceCoverageForOrthoticDevices: boolean,
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months: boolean,
    feelingTiredForNoReasonInTheLastTwoWeeks: boolean,
    lightExerciseForHealthPurposes: boolean,
    canYouOpenTheLidOfAPlasticBottle: boolean,
    diseasesRelatedToOrthopedics: Array< string | null >,
    sprainLocation?: string | null,
    fractureLocation?: string | null,
    diseasesRelatedToOrthopedicsOtherReason?: string | null,
    injuries1: string,
    injuries2: string,
    nameOfDrugAllergyMedication: string,
    nameOfMedicationIfAllergicToAnesthesia: string,
    otherAllergies: Array< string | null >,
    otherAllergiesOtherReason?: string | null,
    medicationsCurrentlyBeingTaken: Array< string | null >,
    medicationsCurrentlyBeingTakenOtherReason?: string | null,
    supplementsCurrentlyBeingTaken: string,
    aboutCigarettes: Array< string | null >,
    numberOfCigarettesSmokedDaily: number,
    numberOfYearsSmoked: number,
    aboutAlcohol: Array< string | null >,
    pregnancy: boolean,
    historyOfChildbirth: boolean,
    aboutFamilyDoctor: string,
    primaryNursingCareRequirementAuthorization: Array< string | null >,
    footSymptomsOfConcern: Array< string | null >,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateObservationMutationVariables = {
  input: UpdateObservationInput,
  condition?: ModelObservationConditionInput | null,
};

export type UpdateObservationMutation = {
  updateObservation?:  {
    __typename: "Observation",
    id: string,
    patientId: string,
    reservationId: string,
    height: number,
    weight: number,
    treatmentOfRecentInjuriesReceived: boolean,
    purposeOfExamination: Array< string | null >,
    purposeOfExaminationOtherReason?: string | null,
    areaToBeInspected: string,
    jobType: Array< string | null >,
    jobTypeOtherReason?: string | null,
    workplaceTransferMethod: Array< string | null >,
    workplaceTransferMethodOtherReason?: string | null,
    walkingHabit: Array< string | null >,
    aidsForWalking: Array< string | null >,
    createdInHospitalsAndClinics: Array< string | null >,
    insuranceCoverageForOrthoticDevices: boolean,
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months: boolean,
    feelingTiredForNoReasonInTheLastTwoWeeks: boolean,
    lightExerciseForHealthPurposes: boolean,
    canYouOpenTheLidOfAPlasticBottle: boolean,
    diseasesRelatedToOrthopedics: Array< string | null >,
    sprainLocation?: string | null,
    fractureLocation?: string | null,
    diseasesRelatedToOrthopedicsOtherReason?: string | null,
    injuries1: string,
    injuries2: string,
    nameOfDrugAllergyMedication: string,
    nameOfMedicationIfAllergicToAnesthesia: string,
    otherAllergies: Array< string | null >,
    otherAllergiesOtherReason?: string | null,
    medicationsCurrentlyBeingTaken: Array< string | null >,
    medicationsCurrentlyBeingTakenOtherReason?: string | null,
    supplementsCurrentlyBeingTaken: string,
    aboutCigarettes: Array< string | null >,
    numberOfCigarettesSmokedDaily: number,
    numberOfYearsSmoked: number,
    aboutAlcohol: Array< string | null >,
    pregnancy: boolean,
    historyOfChildbirth: boolean,
    aboutFamilyDoctor: string,
    primaryNursingCareRequirementAuthorization: Array< string | null >,
    footSymptomsOfConcern: Array< string | null >,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteObservationMutationVariables = {
  input: DeleteObservationInput,
  condition?: ModelObservationConditionInput | null,
};

export type DeleteObservationMutation = {
  deleteObservation?:  {
    __typename: "Observation",
    id: string,
    patientId: string,
    reservationId: string,
    height: number,
    weight: number,
    treatmentOfRecentInjuriesReceived: boolean,
    purposeOfExamination: Array< string | null >,
    purposeOfExaminationOtherReason?: string | null,
    areaToBeInspected: string,
    jobType: Array< string | null >,
    jobTypeOtherReason?: string | null,
    workplaceTransferMethod: Array< string | null >,
    workplaceTransferMethodOtherReason?: string | null,
    walkingHabit: Array< string | null >,
    aidsForWalking: Array< string | null >,
    createdInHospitalsAndClinics: Array< string | null >,
    insuranceCoverageForOrthoticDevices: boolean,
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months: boolean,
    feelingTiredForNoReasonInTheLastTwoWeeks: boolean,
    lightExerciseForHealthPurposes: boolean,
    canYouOpenTheLidOfAPlasticBottle: boolean,
    diseasesRelatedToOrthopedics: Array< string | null >,
    sprainLocation?: string | null,
    fractureLocation?: string | null,
    diseasesRelatedToOrthopedicsOtherReason?: string | null,
    injuries1: string,
    injuries2: string,
    nameOfDrugAllergyMedication: string,
    nameOfMedicationIfAllergicToAnesthesia: string,
    otherAllergies: Array< string | null >,
    otherAllergiesOtherReason?: string | null,
    medicationsCurrentlyBeingTaken: Array< string | null >,
    medicationsCurrentlyBeingTakenOtherReason?: string | null,
    supplementsCurrentlyBeingTaken: string,
    aboutCigarettes: Array< string | null >,
    numberOfCigarettesSmokedDaily: number,
    numberOfYearsSmoked: number,
    aboutAlcohol: Array< string | null >,
    pregnancy: boolean,
    historyOfChildbirth: boolean,
    aboutFamilyDoctor: string,
    primaryNursingCareRequirementAuthorization: Array< string | null >,
    footSymptomsOfConcern: Array< string | null >,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateReceptionMutationVariables = {
  input: CreateReceptionInput,
  condition?: ModelReceptionConditionInput | null,
};

export type CreateReceptionMutation = {
  createReception?:  {
    __typename: "Reception",
    id: string,
    patientId: string,
    date: string,
    outpatientId: string,
    outpatientName: string,
    startTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateReceptionMutationVariables = {
  input: UpdateReceptionInput,
  condition?: ModelReceptionConditionInput | null,
};

export type UpdateReceptionMutation = {
  updateReception?:  {
    __typename: "Reception",
    id: string,
    patientId: string,
    date: string,
    outpatientId: string,
    outpatientName: string,
    startTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteReceptionMutationVariables = {
  input: DeleteReceptionInput,
  condition?: ModelReceptionConditionInput | null,
};

export type DeleteReceptionMutation = {
  deleteReception?:  {
    __typename: "Reception",
    id: string,
    patientId: string,
    date: string,
    outpatientId: string,
    outpatientName: string,
    startTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateContractMutationVariables = {
  input: CreateContractInput,
  condition?: ModelContractConditionInput | null,
};

export type CreateContractMutation = {
  createContract?:  {
    __typename: "Contract",
    id: string,
    clinicName: string,
    isMedical: boolean,
    medicalTreatment?:  Array< {
      __typename: "MedicalTreatmentContent",
      title: string,
      detail: string,
    } | null > | null,
    infoAgree: string,
    termsAndConditions: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateContractMutationVariables = {
  input: UpdateContractInput,
  condition?: ModelContractConditionInput | null,
};

export type UpdateContractMutation = {
  updateContract?:  {
    __typename: "Contract",
    id: string,
    clinicName: string,
    isMedical: boolean,
    medicalTreatment?:  Array< {
      __typename: "MedicalTreatmentContent",
      title: string,
      detail: string,
    } | null > | null,
    infoAgree: string,
    termsAndConditions: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteContractMutationVariables = {
  input: DeleteContractInput,
  condition?: ModelContractConditionInput | null,
};

export type DeleteContractMutation = {
  deleteContract?:  {
    __typename: "Contract",
    id: string,
    clinicName: string,
    isMedical: boolean,
    medicalTreatment?:  Array< {
      __typename: "MedicalTreatmentContent",
      title: string,
      detail: string,
    } | null > | null,
    infoAgree: string,
    termsAndConditions: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateNotificationMutationVariables = {
  input: CreateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type CreateNotificationMutation = {
  createNotification?:  {
    __typename: "Notification",
    id: string,
    patientId: string,
    facilityId: string,
    patientIdFacilityId: string,
    createdAt: string,
    altText?: string | null,
    title?: string | null,
    message: string,
    notificationType: string,
    buttonType?: string | null,
    actionType?: string | null,
    actionValue?: Array< string | null > | null,
    choices?: Array< string | null > | null,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type UpdateNotificationMutationVariables = {
  input: UpdateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type UpdateNotificationMutation = {
  updateNotification?:  {
    __typename: "Notification",
    id: string,
    patientId: string,
    facilityId: string,
    patientIdFacilityId: string,
    createdAt: string,
    altText?: string | null,
    title?: string | null,
    message: string,
    notificationType: string,
    buttonType?: string | null,
    actionType?: string | null,
    actionValue?: Array< string | null > | null,
    choices?: Array< string | null > | null,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type DeleteNotificationMutationVariables = {
  input: DeleteNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type DeleteNotificationMutation = {
  deleteNotification?:  {
    __typename: "Notification",
    id: string,
    patientId: string,
    facilityId: string,
    patientIdFacilityId: string,
    createdAt: string,
    altText?: string | null,
    title?: string | null,
    message: string,
    notificationType: string,
    buttonType?: string | null,
    actionType?: string | null,
    actionValue?: Array< string | null > | null,
    choices?: Array< string | null > | null,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type CreateRetryNotificationsMutationVariables = {
  input: CreateRetryNotificationsInput,
  condition?: ModelRetryNotificationsConditionInput | null,
};

export type CreateRetryNotificationsMutation = {
  createRetryNotifications?:  {
    __typename: "RetryNotifications",
    id: string,
    sendMessage: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRetryNotificationsMutationVariables = {
  input: UpdateRetryNotificationsInput,
  condition?: ModelRetryNotificationsConditionInput | null,
};

export type UpdateRetryNotificationsMutation = {
  updateRetryNotifications?:  {
    __typename: "RetryNotifications",
    id: string,
    sendMessage: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRetryNotificationsMutationVariables = {
  input: DeleteRetryNotificationsInput,
  condition?: ModelRetryNotificationsConditionInput | null,
};

export type DeleteRetryNotificationsMutation = {
  deleteRetryNotifications?:  {
    __typename: "RetryNotifications",
    id: string,
    sendMessage: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFacilityPatientsMutationVariables = {
  input: CreateFacilityPatientsInput,
  condition?: ModelFacilityPatientsConditionInput | null,
};

export type CreateFacilityPatientsMutation = {
  createFacilityPatients?:  {
    __typename: "FacilityPatients",
    facilityId: string,
    patientId: string,
    lineUserId?: string | null,
    karteNo?: string | null,
    vip: boolean,
    isFirstVisit?: boolean | null,
    memberStatus?: string | null,
    insuranceType?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFacilityPatientsMutationVariables = {
  input: UpdateFacilityPatientsInput,
  condition?: ModelFacilityPatientsConditionInput | null,
};

export type UpdateFacilityPatientsMutation = {
  updateFacilityPatients?:  {
    __typename: "FacilityPatients",
    facilityId: string,
    patientId: string,
    lineUserId?: string | null,
    karteNo?: string | null,
    vip: boolean,
    isFirstVisit?: boolean | null,
    memberStatus?: string | null,
    insuranceType?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFacilityPatientsMutationVariables = {
  input: DeleteFacilityPatientsInput,
  condition?: ModelFacilityPatientsConditionInput | null,
};

export type DeleteFacilityPatientsMutation = {
  deleteFacilityPatients?:  {
    __typename: "FacilityPatients",
    facilityId: string,
    patientId: string,
    lineUserId?: string | null,
    karteNo?: string | null,
    vip: boolean,
    isFirstVisit?: boolean | null,
    memberStatus?: string | null,
    insuranceType?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetPatientQueryVariables = {
  id: string,
};

export type GetPatientQuery = {
  getPatient?:  {
    __typename: "Patient",
    id: string,
    facilityId: string,
    karteNo?: string | null,
    zipCode?: string | null,
    address?: string | null,
    state?: string | null,
    city?: string | null,
    familyName: string,
    firstName: string,
    familyNameKana: string,
    firstNameKana: string,
    email: string,
    phoneNumber: string,
    dateOfBirth?: string | null,
    gender?: number | null,
    mynumbercard?: boolean | null,
    seinenhikoukennin?: boolean | null,
    vip: boolean,
    memberStatus?: string | null,
    contractState?:  Array< {
      __typename: "AgreeState",
      clinicName: string,
      termsAgree?: number | null,
      infoAgree?: number | null,
    } | null > | null,
    kaisekiKenriNoKyodaku?: boolean | null,
    eturankenKyodaku?: boolean | null,
    tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
    koukokuUketoriNoKyodaku?: boolean | null,
    minimumAdvertisedPrice?: number | null,
    designationOfMinimumTransactionPrice?: number | null,
    kouekiKenkyuuMushouRiyou?: boolean | null,
    houkatuDoui?: boolean | null,
    torihikiGoui?: boolean | null,
    tudoKeiyakuKakunin?: boolean | null,
    lineUserId?: string | null,
    isWalletCreate?: boolean | null,
    createdAt: string,
    updatedAt: string,
    isLineNotificationEnabled?: boolean | null,
    owner?: string | null,
  } | null,
};

export type ListPatientsQueryVariables = {
  filter?: ModelPatientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPatientsQuery = {
  listPatients?:  {
    __typename: "ModelPatientConnection",
    items:  Array< {
      __typename: "Patient",
      id: string,
      facilityId: string,
      karteNo?: string | null,
      zipCode?: string | null,
      address?: string | null,
      state?: string | null,
      city?: string | null,
      familyName: string,
      firstName: string,
      familyNameKana: string,
      firstNameKana: string,
      email: string,
      phoneNumber: string,
      dateOfBirth?: string | null,
      gender?: number | null,
      mynumbercard?: boolean | null,
      seinenhikoukennin?: boolean | null,
      vip: boolean,
      memberStatus?: string | null,
      kaisekiKenriNoKyodaku?: boolean | null,
      eturankenKyodaku?: boolean | null,
      tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
      koukokuUketoriNoKyodaku?: boolean | null,
      minimumAdvertisedPrice?: number | null,
      designationOfMinimumTransactionPrice?: number | null,
      kouekiKenkyuuMushouRiyou?: boolean | null,
      houkatuDoui?: boolean | null,
      torihikiGoui?: boolean | null,
      tudoKeiyakuKakunin?: boolean | null,
      lineUserId?: string | null,
      isWalletCreate?: boolean | null,
      createdAt: string,
      updatedAt: string,
      isLineNotificationEnabled?: boolean | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetReservationQueryVariables = {
  id: string,
};

export type GetReservationQuery = {
  getReservation?:  {
    __typename: "Reservation",
    id: string,
    patientId: string,
    symptoms: string,
    symptomOthers: string,
    examinationMenuId: string,
    remarks: string,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListReservationsQueryVariables = {
  filter?: ModelReservationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReservationsQuery = {
  listReservations?:  {
    __typename: "ModelReservationConnection",
    items:  Array< {
      __typename: "Reservation",
      id: string,
      patientId: string,
      symptoms: string,
      symptomOthers: string,
      examinationMenuId: string,
      remarks: string,
      dateTime: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetObservationQueryVariables = {
  id: string,
};

export type GetObservationQuery = {
  getObservation?:  {
    __typename: "Observation",
    id: string,
    patientId: string,
    reservationId: string,
    height: number,
    weight: number,
    treatmentOfRecentInjuriesReceived: boolean,
    purposeOfExamination: Array< string | null >,
    purposeOfExaminationOtherReason?: string | null,
    areaToBeInspected: string,
    jobType: Array< string | null >,
    jobTypeOtherReason?: string | null,
    workplaceTransferMethod: Array< string | null >,
    workplaceTransferMethodOtherReason?: string | null,
    walkingHabit: Array< string | null >,
    aidsForWalking: Array< string | null >,
    createdInHospitalsAndClinics: Array< string | null >,
    insuranceCoverageForOrthoticDevices: boolean,
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months: boolean,
    feelingTiredForNoReasonInTheLastTwoWeeks: boolean,
    lightExerciseForHealthPurposes: boolean,
    canYouOpenTheLidOfAPlasticBottle: boolean,
    diseasesRelatedToOrthopedics: Array< string | null >,
    sprainLocation?: string | null,
    fractureLocation?: string | null,
    diseasesRelatedToOrthopedicsOtherReason?: string | null,
    injuries1: string,
    injuries2: string,
    nameOfDrugAllergyMedication: string,
    nameOfMedicationIfAllergicToAnesthesia: string,
    otherAllergies: Array< string | null >,
    otherAllergiesOtherReason?: string | null,
    medicationsCurrentlyBeingTaken: Array< string | null >,
    medicationsCurrentlyBeingTakenOtherReason?: string | null,
    supplementsCurrentlyBeingTaken: string,
    aboutCigarettes: Array< string | null >,
    numberOfCigarettesSmokedDaily: number,
    numberOfYearsSmoked: number,
    aboutAlcohol: Array< string | null >,
    pregnancy: boolean,
    historyOfChildbirth: boolean,
    aboutFamilyDoctor: string,
    primaryNursingCareRequirementAuthorization: Array< string | null >,
    footSymptomsOfConcern: Array< string | null >,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListObservationsQueryVariables = {
  filter?: ModelObservationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListObservationsQuery = {
  listObservations?:  {
    __typename: "ModelObservationConnection",
    items:  Array< {
      __typename: "Observation",
      id: string,
      patientId: string,
      reservationId: string,
      height: number,
      weight: number,
      treatmentOfRecentInjuriesReceived: boolean,
      purposeOfExamination: Array< string | null >,
      purposeOfExaminationOtherReason?: string | null,
      areaToBeInspected: string,
      jobType: Array< string | null >,
      jobTypeOtherReason?: string | null,
      workplaceTransferMethod: Array< string | null >,
      workplaceTransferMethodOtherReason?: string | null,
      walkingHabit: Array< string | null >,
      aidsForWalking: Array< string | null >,
      createdInHospitalsAndClinics: Array< string | null >,
      insuranceCoverageForOrthoticDevices: boolean,
      unintentionalWeightLossOfMoreThan2kgInTheLast6Months: boolean,
      feelingTiredForNoReasonInTheLastTwoWeeks: boolean,
      lightExerciseForHealthPurposes: boolean,
      canYouOpenTheLidOfAPlasticBottle: boolean,
      diseasesRelatedToOrthopedics: Array< string | null >,
      sprainLocation?: string | null,
      fractureLocation?: string | null,
      diseasesRelatedToOrthopedicsOtherReason?: string | null,
      injuries1: string,
      injuries2: string,
      nameOfDrugAllergyMedication: string,
      nameOfMedicationIfAllergicToAnesthesia: string,
      otherAllergies: Array< string | null >,
      otherAllergiesOtherReason?: string | null,
      medicationsCurrentlyBeingTaken: Array< string | null >,
      medicationsCurrentlyBeingTakenOtherReason?: string | null,
      supplementsCurrentlyBeingTaken: string,
      aboutCigarettes: Array< string | null >,
      numberOfCigarettesSmokedDaily: number,
      numberOfYearsSmoked: number,
      aboutAlcohol: Array< string | null >,
      pregnancy: boolean,
      historyOfChildbirth: boolean,
      aboutFamilyDoctor: string,
      primaryNursingCareRequirementAuthorization: Array< string | null >,
      footSymptomsOfConcern: Array< string | null >,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetReceptionQueryVariables = {
  id: string,
};

export type GetReceptionQuery = {
  getReception?:  {
    __typename: "Reception",
    id: string,
    patientId: string,
    date: string,
    outpatientId: string,
    outpatientName: string,
    startTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListReceptionsQueryVariables = {
  filter?: ModelReceptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReceptionsQuery = {
  listReceptions?:  {
    __typename: "ModelReceptionConnection",
    items:  Array< {
      __typename: "Reception",
      id: string,
      patientId: string,
      date: string,
      outpatientId: string,
      outpatientName: string,
      startTime: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetContractQueryVariables = {
  id: string,
};

export type GetContractQuery = {
  getContract?:  {
    __typename: "Contract",
    id: string,
    clinicName: string,
    isMedical: boolean,
    medicalTreatment?:  Array< {
      __typename: "MedicalTreatmentContent",
      title: string,
      detail: string,
    } | null > | null,
    infoAgree: string,
    termsAndConditions: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListContractsQueryVariables = {
  filter?: ModelContractFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContractsQuery = {
  listContracts?:  {
    __typename: "ModelContractConnection",
    items:  Array< {
      __typename: "Contract",
      id: string,
      clinicName: string,
      isMedical: boolean,
      infoAgree: string,
      termsAndConditions: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetNotificationQueryVariables = {
  id: string,
};

export type GetNotificationQuery = {
  getNotification?:  {
    __typename: "Notification",
    id: string,
    patientId: string,
    facilityId: string,
    patientIdFacilityId: string,
    createdAt: string,
    altText?: string | null,
    title?: string | null,
    message: string,
    notificationType: string,
    buttonType?: string | null,
    actionType?: string | null,
    actionValue?: Array< string | null > | null,
    choices?: Array< string | null > | null,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type ListNotificationsQueryVariables = {
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotificationsQuery = {
  listNotifications?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      patientId: string,
      facilityId: string,
      patientIdFacilityId: string,
      createdAt: string,
      altText?: string | null,
      title?: string | null,
      message: string,
      notificationType: string,
      buttonType?: string | null,
      actionType?: string | null,
      actionValue?: Array< string | null > | null,
      choices?: Array< string | null > | null,
      isRead: boolean,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByPatientIdQueryVariables = {
  patientId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByPatientIdQuery = {
  notificationsByPatientId?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      patientId: string,
      facilityId: string,
      patientIdFacilityId: string,
      createdAt: string,
      altText?: string | null,
      title?: string | null,
      message: string,
      notificationType: string,
      buttonType?: string | null,
      actionType?: string | null,
      actionValue?: Array< string | null > | null,
      choices?: Array< string | null > | null,
      isRead: boolean,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByPatientIdFacilityIdAndCreatedAtQueryVariables = {
  patientIdFacilityId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByPatientIdFacilityIdAndCreatedAtQuery = {
  notificationsByPatientIdFacilityIdAndCreatedAt?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      patientId: string,
      facilityId: string,
      patientIdFacilityId: string,
      createdAt: string,
      altText?: string | null,
      title?: string | null,
      message: string,
      notificationType: string,
      buttonType?: string | null,
      actionType?: string | null,
      actionValue?: Array< string | null > | null,
      choices?: Array< string | null > | null,
      isRead: boolean,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRetryNotificationsQueryVariables = {
  id: string,
};

export type GetRetryNotificationsQuery = {
  getRetryNotifications?:  {
    __typename: "RetryNotifications",
    id: string,
    sendMessage: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRetryNotificationsQueryVariables = {
  id?: string | null,
  filter?: ModelRetryNotificationsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListRetryNotificationsQuery = {
  listRetryNotifications?:  {
    __typename: "ModelRetryNotificationsConnection",
    items:  Array< {
      __typename: "RetryNotifications",
      id: string,
      sendMessage: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFacilityPatientsQueryVariables = {
  patientId: string,
  facilityId: string,
};

export type GetFacilityPatientsQuery = {
  getFacilityPatients?:  {
    __typename: "FacilityPatients",
    facilityId: string,
    patientId: string,
    lineUserId?: string | null,
    karteNo?: string | null,
    vip: boolean,
    isFirstVisit?: boolean | null,
    memberStatus?: string | null,
    insuranceType?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFacilityPatientsQueryVariables = {
  patientId?: string | null,
  facilityId?: ModelIDKeyConditionInput | null,
  filter?: ModelFacilityPatientsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFacilityPatientsQuery = {
  listFacilityPatients?:  {
    __typename: "ModelFacilityPatientsConnection",
    items:  Array< {
      __typename: "FacilityPatients",
      facilityId: string,
      patientId: string,
      lineUserId?: string | null,
      karteNo?: string | null,
      vip: boolean,
      isFirstVisit?: boolean | null,
      memberStatus?: string | null,
      insuranceType?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FacilityPatientsByLineUserIdQueryVariables = {
  lineUserId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFacilityPatientsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FacilityPatientsByLineUserIdQuery = {
  facilityPatientsByLineUserId?:  {
    __typename: "ModelFacilityPatientsConnection",
    items:  Array< {
      __typename: "FacilityPatients",
      facilityId: string,
      patientId: string,
      lineUserId?: string | null,
      karteNo?: string | null,
      vip: boolean,
      isFirstVisit?: boolean | null,
      memberStatus?: string | null,
      insuranceType?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListFacilityPatientsByFacilityIdAndKarteNoQueryVariables = {
  karteNo: string,
  facilityId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFacilityPatientsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFacilityPatientsByFacilityIdAndKarteNoQuery = {
  listFacilityPatientsByFacilityIdAndKarteNo?:  {
    __typename: "ModelFacilityPatientsConnection",
    items:  Array< {
      __typename: "FacilityPatients",
      facilityId: string,
      patientId: string,
      lineUserId?: string | null,
      karteNo?: string | null,
      vip: boolean,
      isFirstVisit?: boolean | null,
      memberStatus?: string | null,
      insuranceType?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreatePatientSubscriptionVariables = {
  filter?: ModelSubscriptionPatientFilterInput | null,
  owner?: string | null,
};

export type OnCreatePatientSubscription = {
  onCreatePatient?:  {
    __typename: "Patient",
    id: string,
    facilityId: string,
    karteNo?: string | null,
    zipCode?: string | null,
    address?: string | null,
    state?: string | null,
    city?: string | null,
    familyName: string,
    firstName: string,
    familyNameKana: string,
    firstNameKana: string,
    email: string,
    phoneNumber: string,
    dateOfBirth?: string | null,
    gender?: number | null,
    mynumbercard?: boolean | null,
    seinenhikoukennin?: boolean | null,
    vip: boolean,
    memberStatus?: string | null,
    contractState?:  Array< {
      __typename: "AgreeState",
      clinicName: string,
      termsAgree?: number | null,
      infoAgree?: number | null,
    } | null > | null,
    kaisekiKenriNoKyodaku?: boolean | null,
    eturankenKyodaku?: boolean | null,
    tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
    koukokuUketoriNoKyodaku?: boolean | null,
    minimumAdvertisedPrice?: number | null,
    designationOfMinimumTransactionPrice?: number | null,
    kouekiKenkyuuMushouRiyou?: boolean | null,
    houkatuDoui?: boolean | null,
    torihikiGoui?: boolean | null,
    tudoKeiyakuKakunin?: boolean | null,
    lineUserId?: string | null,
    isWalletCreate?: boolean | null,
    createdAt: string,
    updatedAt: string,
    isLineNotificationEnabled?: boolean | null,
    owner?: string | null,
  } | null,
};

export type OnUpdatePatientSubscriptionVariables = {
  filter?: ModelSubscriptionPatientFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePatientSubscription = {
  onUpdatePatient?:  {
    __typename: "Patient",
    id: string,
    facilityId: string,
    karteNo?: string | null,
    zipCode?: string | null,
    address?: string | null,
    state?: string | null,
    city?: string | null,
    familyName: string,
    firstName: string,
    familyNameKana: string,
    firstNameKana: string,
    email: string,
    phoneNumber: string,
    dateOfBirth?: string | null,
    gender?: number | null,
    mynumbercard?: boolean | null,
    seinenhikoukennin?: boolean | null,
    vip: boolean,
    memberStatus?: string | null,
    contractState?:  Array< {
      __typename: "AgreeState",
      clinicName: string,
      termsAgree?: number | null,
      infoAgree?: number | null,
    } | null > | null,
    kaisekiKenriNoKyodaku?: boolean | null,
    eturankenKyodaku?: boolean | null,
    tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
    koukokuUketoriNoKyodaku?: boolean | null,
    minimumAdvertisedPrice?: number | null,
    designationOfMinimumTransactionPrice?: number | null,
    kouekiKenkyuuMushouRiyou?: boolean | null,
    houkatuDoui?: boolean | null,
    torihikiGoui?: boolean | null,
    tudoKeiyakuKakunin?: boolean | null,
    lineUserId?: string | null,
    isWalletCreate?: boolean | null,
    createdAt: string,
    updatedAt: string,
    isLineNotificationEnabled?: boolean | null,
    owner?: string | null,
  } | null,
};

export type OnDeletePatientSubscriptionVariables = {
  filter?: ModelSubscriptionPatientFilterInput | null,
  owner?: string | null,
};

export type OnDeletePatientSubscription = {
  onDeletePatient?:  {
    __typename: "Patient",
    id: string,
    facilityId: string,
    karteNo?: string | null,
    zipCode?: string | null,
    address?: string | null,
    state?: string | null,
    city?: string | null,
    familyName: string,
    firstName: string,
    familyNameKana: string,
    firstNameKana: string,
    email: string,
    phoneNumber: string,
    dateOfBirth?: string | null,
    gender?: number | null,
    mynumbercard?: boolean | null,
    seinenhikoukennin?: boolean | null,
    vip: boolean,
    memberStatus?: string | null,
    contractState?:  Array< {
      __typename: "AgreeState",
      clinicName: string,
      termsAgree?: number | null,
      infoAgree?: number | null,
    } | null > | null,
    kaisekiKenriNoKyodaku?: boolean | null,
    eturankenKyodaku?: boolean | null,
    tokumeiKakouJouhouHukuseiNoKyodaku?: boolean | null,
    koukokuUketoriNoKyodaku?: boolean | null,
    minimumAdvertisedPrice?: number | null,
    designationOfMinimumTransactionPrice?: number | null,
    kouekiKenkyuuMushouRiyou?: boolean | null,
    houkatuDoui?: boolean | null,
    torihikiGoui?: boolean | null,
    tudoKeiyakuKakunin?: boolean | null,
    lineUserId?: string | null,
    isWalletCreate?: boolean | null,
    createdAt: string,
    updatedAt: string,
    isLineNotificationEnabled?: boolean | null,
    owner?: string | null,
  } | null,
};

export type OnCreateReservationSubscriptionVariables = {
  filter?: ModelSubscriptionReservationFilterInput | null,
  owner?: string | null,
};

export type OnCreateReservationSubscription = {
  onCreateReservation?:  {
    __typename: "Reservation",
    id: string,
    patientId: string,
    symptoms: string,
    symptomOthers: string,
    examinationMenuId: string,
    remarks: string,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateReservationSubscriptionVariables = {
  filter?: ModelSubscriptionReservationFilterInput | null,
  owner?: string | null,
};

export type OnUpdateReservationSubscription = {
  onUpdateReservation?:  {
    __typename: "Reservation",
    id: string,
    patientId: string,
    symptoms: string,
    symptomOthers: string,
    examinationMenuId: string,
    remarks: string,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteReservationSubscriptionVariables = {
  filter?: ModelSubscriptionReservationFilterInput | null,
  owner?: string | null,
};

export type OnDeleteReservationSubscription = {
  onDeleteReservation?:  {
    __typename: "Reservation",
    id: string,
    patientId: string,
    symptoms: string,
    symptomOthers: string,
    examinationMenuId: string,
    remarks: string,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateObservationSubscriptionVariables = {
  filter?: ModelSubscriptionObservationFilterInput | null,
  owner?: string | null,
};

export type OnCreateObservationSubscription = {
  onCreateObservation?:  {
    __typename: "Observation",
    id: string,
    patientId: string,
    reservationId: string,
    height: number,
    weight: number,
    treatmentOfRecentInjuriesReceived: boolean,
    purposeOfExamination: Array< string | null >,
    purposeOfExaminationOtherReason?: string | null,
    areaToBeInspected: string,
    jobType: Array< string | null >,
    jobTypeOtherReason?: string | null,
    workplaceTransferMethod: Array< string | null >,
    workplaceTransferMethodOtherReason?: string | null,
    walkingHabit: Array< string | null >,
    aidsForWalking: Array< string | null >,
    createdInHospitalsAndClinics: Array< string | null >,
    insuranceCoverageForOrthoticDevices: boolean,
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months: boolean,
    feelingTiredForNoReasonInTheLastTwoWeeks: boolean,
    lightExerciseForHealthPurposes: boolean,
    canYouOpenTheLidOfAPlasticBottle: boolean,
    diseasesRelatedToOrthopedics: Array< string | null >,
    sprainLocation?: string | null,
    fractureLocation?: string | null,
    diseasesRelatedToOrthopedicsOtherReason?: string | null,
    injuries1: string,
    injuries2: string,
    nameOfDrugAllergyMedication: string,
    nameOfMedicationIfAllergicToAnesthesia: string,
    otherAllergies: Array< string | null >,
    otherAllergiesOtherReason?: string | null,
    medicationsCurrentlyBeingTaken: Array< string | null >,
    medicationsCurrentlyBeingTakenOtherReason?: string | null,
    supplementsCurrentlyBeingTaken: string,
    aboutCigarettes: Array< string | null >,
    numberOfCigarettesSmokedDaily: number,
    numberOfYearsSmoked: number,
    aboutAlcohol: Array< string | null >,
    pregnancy: boolean,
    historyOfChildbirth: boolean,
    aboutFamilyDoctor: string,
    primaryNursingCareRequirementAuthorization: Array< string | null >,
    footSymptomsOfConcern: Array< string | null >,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateObservationSubscriptionVariables = {
  filter?: ModelSubscriptionObservationFilterInput | null,
  owner?: string | null,
};

export type OnUpdateObservationSubscription = {
  onUpdateObservation?:  {
    __typename: "Observation",
    id: string,
    patientId: string,
    reservationId: string,
    height: number,
    weight: number,
    treatmentOfRecentInjuriesReceived: boolean,
    purposeOfExamination: Array< string | null >,
    purposeOfExaminationOtherReason?: string | null,
    areaToBeInspected: string,
    jobType: Array< string | null >,
    jobTypeOtherReason?: string | null,
    workplaceTransferMethod: Array< string | null >,
    workplaceTransferMethodOtherReason?: string | null,
    walkingHabit: Array< string | null >,
    aidsForWalking: Array< string | null >,
    createdInHospitalsAndClinics: Array< string | null >,
    insuranceCoverageForOrthoticDevices: boolean,
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months: boolean,
    feelingTiredForNoReasonInTheLastTwoWeeks: boolean,
    lightExerciseForHealthPurposes: boolean,
    canYouOpenTheLidOfAPlasticBottle: boolean,
    diseasesRelatedToOrthopedics: Array< string | null >,
    sprainLocation?: string | null,
    fractureLocation?: string | null,
    diseasesRelatedToOrthopedicsOtherReason?: string | null,
    injuries1: string,
    injuries2: string,
    nameOfDrugAllergyMedication: string,
    nameOfMedicationIfAllergicToAnesthesia: string,
    otherAllergies: Array< string | null >,
    otherAllergiesOtherReason?: string | null,
    medicationsCurrentlyBeingTaken: Array< string | null >,
    medicationsCurrentlyBeingTakenOtherReason?: string | null,
    supplementsCurrentlyBeingTaken: string,
    aboutCigarettes: Array< string | null >,
    numberOfCigarettesSmokedDaily: number,
    numberOfYearsSmoked: number,
    aboutAlcohol: Array< string | null >,
    pregnancy: boolean,
    historyOfChildbirth: boolean,
    aboutFamilyDoctor: string,
    primaryNursingCareRequirementAuthorization: Array< string | null >,
    footSymptomsOfConcern: Array< string | null >,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteObservationSubscriptionVariables = {
  filter?: ModelSubscriptionObservationFilterInput | null,
  owner?: string | null,
};

export type OnDeleteObservationSubscription = {
  onDeleteObservation?:  {
    __typename: "Observation",
    id: string,
    patientId: string,
    reservationId: string,
    height: number,
    weight: number,
    treatmentOfRecentInjuriesReceived: boolean,
    purposeOfExamination: Array< string | null >,
    purposeOfExaminationOtherReason?: string | null,
    areaToBeInspected: string,
    jobType: Array< string | null >,
    jobTypeOtherReason?: string | null,
    workplaceTransferMethod: Array< string | null >,
    workplaceTransferMethodOtherReason?: string | null,
    walkingHabit: Array< string | null >,
    aidsForWalking: Array< string | null >,
    createdInHospitalsAndClinics: Array< string | null >,
    insuranceCoverageForOrthoticDevices: boolean,
    unintentionalWeightLossOfMoreThan2kgInTheLast6Months: boolean,
    feelingTiredForNoReasonInTheLastTwoWeeks: boolean,
    lightExerciseForHealthPurposes: boolean,
    canYouOpenTheLidOfAPlasticBottle: boolean,
    diseasesRelatedToOrthopedics: Array< string | null >,
    sprainLocation?: string | null,
    fractureLocation?: string | null,
    diseasesRelatedToOrthopedicsOtherReason?: string | null,
    injuries1: string,
    injuries2: string,
    nameOfDrugAllergyMedication: string,
    nameOfMedicationIfAllergicToAnesthesia: string,
    otherAllergies: Array< string | null >,
    otherAllergiesOtherReason?: string | null,
    medicationsCurrentlyBeingTaken: Array< string | null >,
    medicationsCurrentlyBeingTakenOtherReason?: string | null,
    supplementsCurrentlyBeingTaken: string,
    aboutCigarettes: Array< string | null >,
    numberOfCigarettesSmokedDaily: number,
    numberOfYearsSmoked: number,
    aboutAlcohol: Array< string | null >,
    pregnancy: boolean,
    historyOfChildbirth: boolean,
    aboutFamilyDoctor: string,
    primaryNursingCareRequirementAuthorization: Array< string | null >,
    footSymptomsOfConcern: Array< string | null >,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateReceptionSubscriptionVariables = {
  filter?: ModelSubscriptionReceptionFilterInput | null,
  owner?: string | null,
};

export type OnCreateReceptionSubscription = {
  onCreateReception?:  {
    __typename: "Reception",
    id: string,
    patientId: string,
    date: string,
    outpatientId: string,
    outpatientName: string,
    startTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateReceptionSubscriptionVariables = {
  filter?: ModelSubscriptionReceptionFilterInput | null,
  owner?: string | null,
};

export type OnUpdateReceptionSubscription = {
  onUpdateReception?:  {
    __typename: "Reception",
    id: string,
    patientId: string,
    date: string,
    outpatientId: string,
    outpatientName: string,
    startTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteReceptionSubscriptionVariables = {
  filter?: ModelSubscriptionReceptionFilterInput | null,
  owner?: string | null,
};

export type OnDeleteReceptionSubscription = {
  onDeleteReception?:  {
    __typename: "Reception",
    id: string,
    patientId: string,
    date: string,
    outpatientId: string,
    outpatientName: string,
    startTime: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateContractSubscriptionVariables = {
  filter?: ModelSubscriptionContractFilterInput | null,
  owner?: string | null,
};

export type OnCreateContractSubscription = {
  onCreateContract?:  {
    __typename: "Contract",
    id: string,
    clinicName: string,
    isMedical: boolean,
    medicalTreatment?:  Array< {
      __typename: "MedicalTreatmentContent",
      title: string,
      detail: string,
    } | null > | null,
    infoAgree: string,
    termsAndConditions: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateContractSubscriptionVariables = {
  filter?: ModelSubscriptionContractFilterInput | null,
  owner?: string | null,
};

export type OnUpdateContractSubscription = {
  onUpdateContract?:  {
    __typename: "Contract",
    id: string,
    clinicName: string,
    isMedical: boolean,
    medicalTreatment?:  Array< {
      __typename: "MedicalTreatmentContent",
      title: string,
      detail: string,
    } | null > | null,
    infoAgree: string,
    termsAndConditions: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteContractSubscriptionVariables = {
  filter?: ModelSubscriptionContractFilterInput | null,
  owner?: string | null,
};

export type OnDeleteContractSubscription = {
  onDeleteContract?:  {
    __typename: "Contract",
    id: string,
    clinicName: string,
    isMedical: boolean,
    medicalTreatment?:  Array< {
      __typename: "MedicalTreatmentContent",
      title: string,
      detail: string,
    } | null > | null,
    infoAgree: string,
    termsAndConditions: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
};

export type OnCreateNotificationSubscription = {
  onCreateNotification?:  {
    __typename: "Notification",
    id: string,
    patientId: string,
    facilityId: string,
    patientIdFacilityId: string,
    createdAt: string,
    altText?: string | null,
    title?: string | null,
    message: string,
    notificationType: string,
    buttonType?: string | null,
    actionType?: string | null,
    actionValue?: Array< string | null > | null,
    choices?: Array< string | null > | null,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type OnUpdateNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
};

export type OnUpdateNotificationSubscription = {
  onUpdateNotification?:  {
    __typename: "Notification",
    id: string,
    patientId: string,
    facilityId: string,
    patientIdFacilityId: string,
    createdAt: string,
    altText?: string | null,
    title?: string | null,
    message: string,
    notificationType: string,
    buttonType?: string | null,
    actionType?: string | null,
    actionValue?: Array< string | null > | null,
    choices?: Array< string | null > | null,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type OnDeleteNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
};

export type OnDeleteNotificationSubscription = {
  onDeleteNotification?:  {
    __typename: "Notification",
    id: string,
    patientId: string,
    facilityId: string,
    patientIdFacilityId: string,
    createdAt: string,
    altText?: string | null,
    title?: string | null,
    message: string,
    notificationType: string,
    buttonType?: string | null,
    actionType?: string | null,
    actionValue?: Array< string | null > | null,
    choices?: Array< string | null > | null,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type OnCreateRetryNotificationsSubscriptionVariables = {
  filter?: ModelSubscriptionRetryNotificationsFilterInput | null,
};

export type OnCreateRetryNotificationsSubscription = {
  onCreateRetryNotifications?:  {
    __typename: "RetryNotifications",
    id: string,
    sendMessage: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRetryNotificationsSubscriptionVariables = {
  filter?: ModelSubscriptionRetryNotificationsFilterInput | null,
};

export type OnUpdateRetryNotificationsSubscription = {
  onUpdateRetryNotifications?:  {
    __typename: "RetryNotifications",
    id: string,
    sendMessage: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRetryNotificationsSubscriptionVariables = {
  filter?: ModelSubscriptionRetryNotificationsFilterInput | null,
};

export type OnDeleteRetryNotificationsSubscription = {
  onDeleteRetryNotifications?:  {
    __typename: "RetryNotifications",
    id: string,
    sendMessage: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateFacilityPatientsSubscriptionVariables = {
  filter?: ModelSubscriptionFacilityPatientsFilterInput | null,
};

export type OnCreateFacilityPatientsSubscription = {
  onCreateFacilityPatients?:  {
    __typename: "FacilityPatients",
    facilityId: string,
    patientId: string,
    lineUserId?: string | null,
    karteNo?: string | null,
    vip: boolean,
    isFirstVisit?: boolean | null,
    memberStatus?: string | null,
    insuranceType?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFacilityPatientsSubscriptionVariables = {
  filter?: ModelSubscriptionFacilityPatientsFilterInput | null,
};

export type OnUpdateFacilityPatientsSubscription = {
  onUpdateFacilityPatients?:  {
    __typename: "FacilityPatients",
    facilityId: string,
    patientId: string,
    lineUserId?: string | null,
    karteNo?: string | null,
    vip: boolean,
    isFirstVisit?: boolean | null,
    memberStatus?: string | null,
    insuranceType?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFacilityPatientsSubscriptionVariables = {
  filter?: ModelSubscriptionFacilityPatientsFilterInput | null,
};

export type OnDeleteFacilityPatientsSubscription = {
  onDeleteFacilityPatients?:  {
    __typename: "FacilityPatients",
    facilityId: string,
    patientId: string,
    lineUserId?: string | null,
    karteNo?: string | null,
    vip: boolean,
    isFirstVisit?: boolean | null,
    memberStatus?: string | null,
    insuranceType?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};
